export const delay = (t = Math.random() * 200 + 300) =>
  new Promise(resolve => setTimeout(resolve, t));
